import axios from 'axios';
import { useQuery } from 'react-query';
import { IImage } from 'models/image';
import { normalizeJSONAPIResponse } from 'utils/modelUtils';

export interface PartnerLibrary {
  id: string;
  name: string;
  coursesCount: number;
  image?: IImage;
}

export const usePartnerLibrary = (partnerId: string) => {
  return useQuery<PartnerLibrary>(
    ['partnerLibrary', partnerId],
    async () => {
      if (!partnerId) {
        return {
          id: '0',
          name: 'Library',
          coursesCount: 0,
        };
      }

      try {
        const response = await axios.get(`/api/v3/partners/${partnerId}/partner_library?include=image`);
        return normalizeJSONAPIResponse(response.data);
      } catch (error) {
        console.error('Error fetching partner library:', error);
        return {
          id: '0',
          name: 'Library',
          coursesCount: 0,
        };
      }
    },
    {
      enabled: !!partnerId,
      retry: 2,
    }
  );
};